import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/ui/compat/antd';
import { HomeOutlined, TeamOutlined } from '@/ui/compat/icons';
import useAmicale from '../hooks/useAmicale';
import { buildAssetUrl } from '../../../utils/imageUrl';
import './AmicaleTopBar.css';

const AmicaleTopBar = () => {
  const { t } = useTranslation();
  const { client } = useAmicale();
  const location = useLocation();
  const isOnEspace = location.pathname.startsWith('/espace-amicales');

  const logoSrc = buildAssetUrl(client?.logoUrl);

  return (
    <header className="amicale-topbar">
      <Link to="/" className="amicale-topbar__brand">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={client?.name || 'Amicale'}
            className="amicale-topbar__logo"
          />
        ) : (
          <div className="amicale-topbar__logo amicale-topbar__logo--fallback">
            {(client?.name || 'A').charAt(0).toUpperCase()}
          </div>
        )}
        <div className="amicale-topbar__brand-text">
          <span className="amicale-topbar__brand-eyebrow">{t('amicales.topBar.brandEyebrow')}</span>
          <strong className="amicale-topbar__brand-name">
            {client?.name || 'Amicale'}
          </strong>
        </div>
      </Link>

      <nav className="amicale-topbar__nav">
        {isOnEspace ? (
          <Link to="/">
            <Button
              icon={<HomeOutlined />}
              size="large"
              className="amicale-topbar__btn"
            >
              {t('amicales.topBar.bookingEngine')}
            </Button>
          </Link>
        ) : (
          <Link to="/espace-amicales">
            <Button
              icon={<TeamOutlined />}
              size="large"
              className="amicale-topbar__btn"
            >
              {t('amicales.topBar.validationSpace')}
            </Button>
          </Link>
        )}
      </nav>
    </header>
  );
};

export default AmicaleTopBar;
